import { render, staticRenderFns } from "./create-or-edit-feedback.vue?vue&type=template&id=6a966b49&scoped=true"
import script from "./create-or-edit-feedback.vue?vue&type=script&lang=js"
export * from "./create-or-edit-feedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a966b49",
  null
  
)

export default component.exports